module.exports = __webpack_public_path__ + "07c9f62ea2424860b29a5bfc3ac21fd5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/flask-blue.png
// module id = 2637
// module chunks = 0